import './style.scss';
import $ from "jquery";
import Flickity from 'flickity';
import 'flickity-imagesloaded';

$(document).ready(() => {
    $('.wp-block-keztablocks-carousel .wp-block-keztablocks-carousel__items').flickity({
        pageDots: false,
        prevNextButtons: false,
        groupCells: false,
        contain: true,
        imagesLoaded: true,
        percentPosition: true,
        wrapAround: true,
        autoPlay: 4000,
        adaptiveHeight: true
    });

    if($(".wp-block-keztablocks-carousel__nav-prev").length) {
        $('.wp-block-keztablocks-carousel__nav-prev').on( 'click', function() {
            $('.wp-block-keztablocks-carousel .wp-block-keztablocks-carousel__items').flickity('previous');
        });
    }
    
    if($(".wp-block-keztablocks-carousel__nav-next").length) {
        $('.wp-block-keztablocks-carousel__nav-next').on( 'click', function() {
            $('.wp-block-keztablocks-carousel .wp-block-keztablocks-carousel__items').flickity('next');
        });
    }

});